import React, { useEffect } from 'react';
import 'react-phone-input-2/lib/style.css';
import PhoneInput from 'react-phone-input-2';
import { Control, Controller } from 'react-hook-form';
import { TelInputProps } from '@models';

export function TelInput(telInputProps: TelInputProps): React.JSX.Element {
    const [state, onChange] = React.useState('');
    const [validPhoneNumber, SetValidPhoneNumber] = React.useState(false);

    const validatePhoneNumber = (
        inputNumber: string,
        country: any,
        isDirty: boolean,
        phoneLength: number
    ) => {
        if (isDirty) {
            console.log("is drity", isDirty);
            const mobileRegex = /^(\([0-9]{3}\)|[0-9]{3})( |-)?([0-9]{3}( |-)?[0-9]{4})$/;
            if (
                inputNumber &&
                inputNumber?.replace(country.dialCode, '')?.trim() === ''
            ) {
                console.log("inputNumber : " + inputNumber + " >> " + 1);
                SetValidPhoneNumber(false);
                return false;
            } else if (inputNumber.length < phoneLength) {
                SetValidPhoneNumber(false);
                console.log("inputNumber : " + inputNumber + " >> " + 2);
                return false;
            } else if (!mobileRegex.test(inputNumber)) {
                SetValidPhoneNumber(false);
                console.log("inputNumber : " + inputNumber + " >> " + 3);
                return false;
            }

            SetValidPhoneNumber(true);
            return true;
        }
        SetValidPhoneNumber(false);
        return false;
    };

    return (
        <Controller
            name={telInputProps.name}
            control={telInputProps.useFormMethods?.control}
            render={(props) => {
                return (
                    <PhoneInput
                        onChange={(e) => {
                            // telInputProps.useFormMethods.trigger();
                            props.field.onChange(e);
                        }}
                        inputStyle={{ width: '100%' }}
                        inputProps={{
                            id: telInputProps.name,
                            name: telInputProps.name,
                            required: telInputProps.required,
                            autoComplete: 'none',
                            'data-testid': 'input-id',
                        }}
                        country={'us'}
                        onlyCountries={['us']}
                        value={props.field.value}
                        disableCountryCode={true}
                        disableDropdown={true}
                        alwaysDefaultMask={true}
                        defaultMask='(...) ...-....'
                        placeholder="Enter Mobile Number"
                        // isValid={(inputNumber, country: any, countries) => {
                        //     const phoneLength = 10;
                        //     return validatePhoneNumber(
                        //         inputNumber,
                        //         country,
                        //         props.formState.isDirty,
                        //         phoneLength
                        //     );
                        // }}
                        specialLabel=""
                    />
                );
            }}
            rules={{
                required: {
                    value: telInputProps.required,
                    message: telInputProps.schema?.errorMessage?.required || 'Please enter phone number'
                },

                // validate: () => validPhoneNumber || telInputProps.schema?.errorMessage?.validate,
            }}

        />
    );
};

